<template>
  <div>
    <div v-show="hasMessage">
      <div class="message align-items-center">
        <label>{{ alertMessage }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageMessageArea',
  props: {
    alertMessage: {
      type: String,
      default: ''
    },
    hasMessage: Boolean
  }
}
</script>

<style scoped lang="scss">
.message {
  margin: 1em 0 1em 0;
  padding: 1em 0 1em 0;
  align-items: center;
}
label {
  width: 100%;
  text-align: center;
}
</style>
